require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-take-home-projects-p-2-p-video-chat-application.json") })
        }
      }, "path---coding-interview-prep-take-home-projects-p-2-p-video-chat-application");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-take-home-projects-p-2-p-video-chat-application!./.cache/json/coding-interview-prep-take-home-projects-p-2-p-video-chat-application.json
// module id = 1942
// module chunks = 231608221292675